import { Panel } from '../panel.class';

export const isRightPanelCfn = (panel: Panel, frontPanelId: string | null): boolean => {
	// can't determine side panel without island frontpanelid
	if (frontPanelId === null) return false;

	// can't be the side panel if it's the front panel
	if (panel.id === frontPanelId) return false;

	const { connections } = panel;
	return connections?.left?.targetPanelId === frontPanelId;
};
